/**
 * Crea y exporta una constante equivalente al EnumEstadoOrdenInventario del DAL
 */
export const EnumEstadoOrdenInventario = {

  INVENTARIO: {codigoEstado: 1, nombre: "Importación Estándar"},

  IMPORTACION: {codigoEstado: 2, nombre: "Importación Limitada"},
}